export default "__VITE_ASSET__CHNPmYOw__"